import { render, staticRenderFns } from "./DiamondTierModal.vue?vue&type=template&id=0013a6b9&scoped=true"
import script from "./DiamondTierModal.vue?vue&type=script&lang=js"
export * from "./DiamondTierModal.vue?vue&type=script&lang=js"
import style0 from "./DiamondTierModal.vue?vue&type=style&index=0&id=0013a6b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013a6b9",
  null
  
)

export default component.exports